import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Chat } from '../interfaces/chat.type';
import { Files } from '../interfaces/file-manager.type';
import { Mail } from '../interfaces/mail.type';
import { createRequestBody } from '../util';

@Injectable({ providedIn: 'root' })
export class AppsService {
    constructor(private http: HttpClient) {}

    public getChatJSON(): Observable<Chat[]> {
        return this.http.get<Chat[]>('./assets/chat-data.json');
    }

    public getFileManagerJson(): Observable<Files[]> {
        return this.http.get<Files[]>('./assets/data/apps/file-manager-data.json');
    }

    public getMailJson(): Observable<Mail[]> {
        return this.http.get<Mail[]>('./assets/data/apps/mail-data.json');
    }

    public getProjectListJson(): Observable<any[]> {
        return this.http.get<any[]>('./assets/data/apps/project-list-data.json');
    }
    queryStatusCRM(req): Observable<any> {
        const options = createRequestBody(req);
        return this.http.get<any[]>(environment.CRM_API_URL + 'api/crmStatus/', { observe: 'response' });
    }
}
